import { type ClassValue, clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

/**
 * Semantic L2 layout tokens from tokens.css / @theme must participate in
 * twMerge conflict groups — otherwise cn(LIST_PAGE_SHELL, "max-w-narrow")
 * keeps BOTH max-w-list and max-w-narrow (silent layout bugs).
 */
const twMerge = extendTailwindMerge({
	extend: {
		theme: {
			// --spacing-* → p-*/m-*/gap-*/space-y-* utilities
			spacing: [
				"page-x",
				"page-x-lg",
				"page-y",
				"section",
				"cluster",
				"inline",
				"pad-row",
				"pad-card",
				"pad-panel",
				"pad-panel-lg",
				"grid",
				"stack",
				"touch",
				"fab-gap",
			],
		},
		classGroups: {
			// --max-width-* → max-w-*
			"max-w": [{ "max-w": ["list", "workspace", "reading", "form", "narrow"] }],
			// --width-rail → w-rail; --width-rail-compact → w-rail-compact
			w: [{ w: ["rail", "rail-compact"] }],
		},
	},
});

export function cn(...inputs: ClassValue[]): string {
	return twMerge(clsx(inputs));
}
